export const HUBSPOT_CONFIG = {
  subscribe: {
    portalId: '46037834',
    formId: 'c8a22b52-23bf-46b7-aed6-28a27ecd9fbe',
    target: `#hubspot-form-wrapper-subscribe`,
  },
}
